import * as React from 'react';

import ElectricEnergySvg from '../Svg/electricEnergy';
import HomeSvg from '../Svg/home';
import NaturalGasSvg from '../Svg/naturalGas';
import PersonSvg from '../Svg/person';

import Localization from '../../config/localization';

import { GetAddress } from '../../lib/address';
import { GetName, ToString } from '../../lib/utils';

class Client extends React.Component<Client.IProps, Client.IState> {
  renderUtilityType = () => {
    if (!this.props.showUtilityType) {
      return null;
    } else if (this.props.isNaturalGas) {
      return (
        <div className="mx-auto d-flex my-2 text-capitalize">
          <NaturalGasSvg className="m-2" />
          <p className="d-inline-block align-middle my-auto h-100">{Localization.beneficiaryAddNaturalGasLabel}</p>
        </div>
      );
    }

    return (
      <div className="mx-auto d-flex my-2 text-capitalize">
        <ElectricEnergySvg className="m-2" />
        <p className="d-inline-block align-middle my-auto h-100">{Localization.beneficiaryAddElectricEnergyLabel}</p>
      </div>
    );
  };

  render() {
    const {
      partner = {} as Partner.IPartner,
      address = partner.consumptionPoints && partner.consumptionPoints[0] && partner.consumptionPoints[0].address,
      consumptionPointCode = partner.consumptionPoints && partner.consumptionPoints[0] && partner.consumptionPoints[0].consumptionPointCode
    } = this.props;

    return (
      <div className={`card ${ToString(this.props.extraClassName)}`}>
        <div className="card-body">
          {!this.props.hideTitle &&
          <h4 className="card-title eon-title eon-darkgrey force-wrap">{Localization.beneficiaryAddClient}</h4>}
          <div className={!this.props.hideTitle ? 'mt-4' : ''}>
            <div className="mx-auto d-flex my-2 partner-container">
              <PersonSvg className="align-baseline m-2" />
              <div className="d-inline-block text-left">
                <h5 className="eon-title eon-middle-grey text-capitalize">
                  {GetName({
                    firstName: partner.firstName || partner.companyName,
                    lastName: partner.lastName || partner.companyName2
                  })}
                </h5>
                <h5 className="client-code eon-title eon-darkgrey text-capitalize">{partner.partnerCode}</h5>
              </div>
            </div>
            {address && <div className="mx-auto d-flex my-2 consumption-point-container">
              <HomeSvg className="align-baseline m-2" />
              <div className="d-inline-block text-left">
                <h5 className="eon-title eon-middle-grey text-capitalize">
                  {GetAddress(address)}
                </h5>
                <h5 className="client-code eon-title eon-darkgrey text-capitalize">
                  {ToString(consumptionPointCode)}
                </h5>
              </div>
            </div>}
            {this.renderUtilityType()}
          </div>
        </div>
      </div>
    );
  }
}

export default Client;
